import { FC } from "react";
import Card from "../Card";
import { CodeMetricsData } from "@/@types/home";
import { Code, FileText, Zap, Files } from "lucide-react";

interface CodeMetricsProps {
  shredsTestsData: CodeMetricsData[] | undefined;
}

const CodeMetrics: FC<CodeMetricsProps> = ({ shredsTestsData }) => {
  const getIcon = (index: number) => {
    switch (index) {
      case 0:
        return <Code className="w-4 h-4" />;
      case 1:
        return <FileText className="w-4 h-4" />;
      case 2:
        return <Zap className="w-4 h-4" />;
      default:
        return <Files className="w-4 h-4" />;
    }
  };
  
  const getBackgroundColor = (color: string) => {
    switch (color) {
      case "progress-purple":
        return "bg-[#dee6ff] text-[#6f6af8]";
      case "progress-green":
        return "bg-[#e8fdde] text-[#46d64b]";
      case "progress-blue":
        return "bg-[#e5f6ff] text-[#3da5f4]";
      default:
        return "bg-[#fff6cc] text-[#ffcd3f]";
    }
  };
  
  if (!shredsTestsData || shredsTestsData.length === 0) {
    return (
      <Card borderColor="[#dbe0f6]" bgColor="white" minHeight="[24rem]">
        <div className="p-4">
          <div className="flex items-center gap-2 mb-4">
            <img src="/icons/tests.png" alt="Code Metrics" width={25} height={25} />
            <h2 className="text-lg font-bold">Code Stats</h2>
          </div>
          
          <div className="flex flex-col items-center justify-center h-64">
            <Code className="w-8 h-8 text-gray-300 mb-3" />
            <p className="text-sm text-gray-500 text-center">
              No code metrics available
            </p>
            <p className="text-xs text-gray-400 text-center mt-1">
              Statistics will appear here once code data is processed
            </p>
          </div>
        </div>
      </Card>
    );
  }
  
  return (
    <Card borderColor="[#dbe0f6]" bgColor="white" minHeight="[24rem]">
      <div className="p-4">
        <div className="flex items-center gap-2 mb-4">
          <img src="/icons/tests.png" alt="Code Metrics" width={25} height={25} />
          <h2 className="text-lg font-bold">Code Stats</h2>
        </div>
        
        <div className="space-y-3">
          {shredsTestsData.map((metric, index) => (
            <div key={index} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div
                  className={`p-1.5 rounded-lg ${getBackgroundColor(metric.color)}`}
                >
                  {getIcon(index)}
                </div>
                <span className="text-sm text-[#8F95B2]">
                  {metric.name.replace("Total ", "").replace("Average ", "Avg ")}
                </span>
              </div>
              <div className="font-semibold">
                {metric.value.toLocaleString()}
                {metric.name === "Lines/Minute" && " lpm"}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};

export default CodeMetrics;